import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Droplet } from "lucide-react";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading)
    return (
      <div className="grid min-h-screen place-items-center" data-testid="auth-loading">
        <Droplet className="h-10 w-10 animate-pulse text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
